export const Routes = new Map([
  [
    '/',
    {
      title: 'Get Started',
      uiName: 'Get Started',
    },
  ],
  [
    '/get-started',
    {
      title: 'Get Started',
      uiName: 'Get Started',
    },
  ],
  [
    '/select-account-type',
    {
      title: 'Select Account Type',
      uiName: 'Select Account Type',
    },
  ],
  [
    '/paper-account',
    {
      title: 'Paperwork Required',
      uiName: 'Paperwork Required',
    },
  ],
  [
    '/finish-paper-account',
    {
      title: 'Paperwork Complete - Whats Next',
      uiName: 'Paperwork Required',
    },
  ],
  [
    '/cash-allocation',
    {
      title: 'Robo Portfolio - Which Portfolio',
      uiName: 'Questionnaire',
    },
  ],
  [
    '/goal',
    {
      title: 'Robo Portfolio - Goal',
      uiName: 'Questionnaire',
    },
  ],
  [
    '/time-horizon',
    {
      title: 'Robo Portfolio - Time Horizon',
      uiName: 'Questionnaire',
    },
  ],
  [
    '/financial-picture',
    {
      title: 'Robo Portfolio - Financial Picture',
      uiName: 'Questionnaire',
    },
  ],
  [
    '/risk-tolerance',
    {
      title: 'Robo Portfolio - Risk Tolerance',
      uiName: 'Questionnaire',
    },
  ],
  [
    '/strategy-type',
    {
      title: 'Robo Portfolio - Strategy Type',
      uiName: 'Questionnaire',
    },
  ],
  [
    '/retirement',
    {
      title: 'Robo Portfolio - Retirement',
      uiName: 'Questionnaire',
    },
  ],
  [
    '/recommendation',
    {
      title: 'Robo Portfolio - Your Recommended Portfolio',
      uiName: 'Questionnaire',
    },
  ],
  [
    '/explore-other-options',
    {
      title: 'Robo Portfolio - Adjust Your Recommendation',
      uiName: 'Questionnaire',
    },
  ],
  [
    '/personal-info',
    {
      title: 'Basic Information - Personal No Ally Acct',
      uiName: 'Basic Information',
    },
  ],
  [
    '/ssn',
    {
      title: 'Basic Information - Identity Verification',
      uiName: 'Basic Information',
    },
  ],
  [
    '/personal-contact',
    {
      title: 'Basic Information - Contact',
      uiName: 'Basic Information',
    },
  ],
  [
    '/personal-address',
    {
      title: 'Basic Information - Address',
      uiName: 'Basic Information',
    },
  ],
  [
    '/welcome-investor',
    {
      title: 'Welcome Investor',
      uiName: 'Basic Information',
    },
  ],
  [
    '/personal-info-auth',
    {
      title: 'Basic Information - Personal Ally Dep Acct Info Prepop',
      uiName: 'Basic Information',
    },
  ],
  [
    '/personal-info-acm',
    {
      title: 'Basic Information - Personal Ally Dep Acct Info Incomplete',
      uiName: 'Basic Information',
    },
  ],
  [
    '/cip',
    {
      title: 'Basic Information - Identity Verification Questions',
      uiName: 'Basic Information',
    },
  ],
  [
    '/employment-info',
    {
      title: 'Enter Information - Employment',
      uiName: 'Employment Information',
    },
  ],
  [
    '/financial-info',
    {
      title: 'Enter Information - Financial',
      uiName: 'Financial Information',
    },
  ],
  [
    '/investment-objective',
    {
      title: 'Enter Information - Investment Objective',
      uiName: 'Investment Objective',
    },
  ],
  [
    '/investment-preferences',
    {
      title: 'Enter Information - Investment Preferences',
      uiName: 'Investment Preferences',
    },
  ],
  [
    '/trusted-contact',
    {
      title: 'Enter Information - Trusted Contact',
      uiName: 'Trusted Contact',
    },
  ],
  [
    '/joint-info',
    {
      title: 'Enter Information - Joint Holder Personal',
      uiName: 'Joint Holder Information',
    },
  ],
  [
    '/joint-financial-info',
    {
      title: 'Enter Information - Joint Holder Financial',
      uiName: 'Joint Holder Information',
    },
  ],
  [
    '/primary-beneficiary-info',
    {
      title: 'Enter Information - Beneficiary',
      uiName: 'Beneficiary Information',
    },
  ],
  [
    '/edit-beneficiary-info',
    {
      title: 'Enter Information - Edit Beneficiaries',
      uiName: 'Enter Information',
    },
  ],
  [
    '/custodial-minor-info',
    {
      title: 'Enter Information - Custodial Account',
      uiName: 'Custodial Information',
    },
  ],
  [
    '/submit-application',
    {
      title: 'Submit Application',
      uiName: 'Submit Application',
    },
  ],
  [
    '/submit-application-review',
    {
      title: 'Review Information',
      uiName: 'Review Information',
    },
  ],
  [
    '/error-submitting-app',
    {
      title: 'Error Submitting Application',
      uiName: 'Error Submitting Application',
    },
  ],
  [
    '/rejected-app',
    {
      title: 'Rejected Application',
      uiName: 'Rejected Application',
    },
  ],
  [
    '/pending-app',
    {
      title: 'Pending Application',
      uiName: 'Pending Application',
    },
  ],
  [
    '/pending-app-cip',
    {
      title: 'Identity Verification Failed',
      uiName: 'Pending Application',
    },
  ],
  [
    '/document-uploader',
    {
      title: 'We need to verify some information',
      uiName: 'Document Upload',
    },
  ],
  [
    '/document-check-your-inbox',
    {
      title: 'Check your inbox',
      uiName: 'Document Upload',
    },
  ],
  [
    '/document-confirmation-received',
    {
      title: 'Upload successful',
      uiName: 'Document Upload',
    },
  ],
  [
    '/welcome-back',
    {
      title: 'Welcome Back',
      uiName: 'Document Upload',
    },
  ],
  [
    '/funding-choices-streamline',
    {
      title: 'Fund Your Account Authorization',
      uiName: 'Fund Your Account Authorization',
    },
  ],
  [
    '/funding-choices',
    {
      title: 'Funding Choices',
      uiName: 'Fund Your Account',
    },
  ],
  [
    '/fund-by-wire',
    {
      title: 'Fund Your Account - Wire',
      uiName: 'Wire Instructions',
    },
  ],
  [
    '/fund-by-invest-account',
    {
      title: 'Fund Your Account - Journal Request',
      uiName: 'Transfer From Another Account',
    },
  ],
  [
    '/fund-by-check',
    {
      title: 'Fund Your Account - Check',
      uiName: 'Check Instructions',
    },
  ],
  [
    '/fund-by-broker',
    {
      title: 'Fund Your Account - ACATS',
      uiName: 'Transfer From Another Broker',
    },
  ],
  [
    '/fund-by-broker-choose-firm',
    {
      title: 'Fund Your Account - ACATS Choose Broker',
      uiName: 'Transfer From Another Broker',
    },
  ],
  [
    '/fund-by-broker-account',
    {
      title: 'Fund Your Account - ACATS Account Number',
      uiName: 'Transfer From Another Broker',
    },
  ],
  [
    '/fund-by-broker-info',
    {
      title: 'Fund Your Account - ACATS Broker Information',
      uiName: 'Transfer From Another Broker',
    },
  ],
  [
    '/fund-by-broker-manual',
    {
      title: 'Fund Your Account - ACATS Manual Documentation',
      uiName: 'Transfer From Another Broker',
    },
  ],
  [
    '/fund-by-broker-review',
    {
      title: 'Fund Your Account - ACATS Review Your Transfer',
      uiName: 'Transfer From Another Broker',
    },
  ],
  [
    '/fund-by-broker-receipt',
    {
      title: 'Fund Your Account - ACATS Transfer Submitted',
      uiName: 'Transfer From Another Broker',
    },
  ],
  [
    '/fund-aba-routing',
    {
      title: 'Fund Your Account - ABA Routing Number',
      uiName: 'Fund Your Account',
    },
  ],
  [
    '/verify-ach-profile-passed',
    {
      title: 'Verify ACH Passed',
      uiName: 'Fund Your Account',
    },
  ],
  [
    '/verify-ach-profile-failed',
    {
      title: 'Verify ACH Failed',
      uiName: 'Fund Your Account',
    },
  ],
  [
    '/verify-ach-profile-manual',
    {
      title: 'Verify ACH Manual',
      uiName: 'Fund Your Account',
    },
  ],
  [
    '/manual',
    {
      title: 'Verify Your Bank Account',
      uiName: 'Fund Your Account',
    },
  ],
  [
    '/fund-account',
    {
      title: 'Fund Your Account',
      uiName: 'Fund Your Account',
    },
  ],
  [
    '/deposit-funds',
    {
      title: 'Deposit Money Online',
      uiName: 'Deposit Money Online',
    },
  ],
  [
    '/review-deposit-funds',
    {
      title: 'Deposit Money Online - Review',
      uiName: 'Deposit Money Online - Review',
    },
  ],
  [
    '/deposit-funds-ira',
    {
      title: 'Deposit Money Online - IRA',
      uiName: 'Deposit Money Online',
    },
  ],
  [
    '/review-deposit-funds-ira',
    {
      title: 'Deposit Money Online - Review - IRA',
      uiName: 'Deposit Money Online',
    },
  ],
  [
    '/deposit-funds-receipt',
    {
      title: 'Deposit Money Online - Receipt',
      uiName: 'Deposit Money Online',
    },
  ],
  [
    '/credentials',
    {
      title: 'Complete Your Registration',
      uiName: 'Complete Your Registration',
    },
  ],
  [
    '/success',
    {
      title: 'Confirmation',
      uiName: 'Confirmation',
    },
  ],
  [
    '/timed-out',
    {
      title: 'Your Application Timed Out',
      uiName: 'Your Application Timed Out',
    },
  ],
]);
